import { useEffect, useState } from 'react'

import { ABIDescription, FunctionDescription } from '@remixproject/plugin-api'
import { JsonRpcProvider } from 'ethers'

import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'

import { ContractHeader } from './ContractHeader'
import ContractInteractionForm from './ContractInteractionForm'
import { formatBalance } from '../../utils/helpers'
import { useEnvironmentStore } from "../../zustand/environmentStore"
import { TESTNET_RPC_URL } from '../../utils/constants'
import { DeployedContractProps } from '../../types/props'

export const DeployedContract = ({
    client,
    deployedContractsLength,
    contractIdx,
    contractName,
    contractAbi,
    contractAddress,
    gasLimit,
    value
}: DeployedContractProps) => {
    const provider = new JsonRpcProvider(TESTNET_RPC_URL)
    const { publicKey, updateBalance } = useEnvironmentStore()
    const [contractBalance, setContractBalance] = useState(BigInt(0))

    useEffect(() => {
        updateBalances()
    }, [])

    const updateBalances = async () => {
        try {
            const [currentContractBalance, currentBalance] = await Promise.all([
                provider.getBalance(contractAddress),
                provider.getBalance(publicKey)
            ])
            
            setContractBalance(currentContractBalance)
            updateBalance(currentBalance)
        } catch (e) {
            console.error('Failed to update balances:', e)
        }
    }

    const sortContractFunctions = (contractAbi: ABIDescription[]) => {
        const order: Record<string, number> = {
            'payable': 1,
            'nonpayable': 2,
            'view': 3,
            'pure': 3
        }

        return contractAbi
            .filter((item): item is FunctionDescription => 'stateMutability' in item)
            .filter(item => item.type !== 'constructor')
            .sort((a, b) => order[a.stateMutability!] - order[b.stateMutability!])
    }

    return (
        <Card className={deployedContractsLength === 1 ? 'deployed-contracts-accordion-card single' : 'deployed-contracts-accordion-card'}>
            <Card.Header>
                <ContractHeader
                    eventKey={contractIdx}
                    contractName={contractName}
                    contractAddress={contractAddress}
                />
            </Card.Header>
            <Accordion.Collapse eventKey={contractIdx.toString()}>
                <Card.Body>
                    <p className='contract-balance'>
                        <b>Balance: {formatBalance(contractBalance, 4)} COTI</b>
                    </p>
                    <hr />
                    {sortContractFunctions(contractAbi).map((func, functionIdx) => (
                        func.name && func.inputs && func.outputs && func.stateMutability && (
                            <ContractInteractionForm
                                key={`${contractIdx}-${functionIdx}`}
                                client={client}
                                updateBalance={updateBalances}
                                functionIdx={`${contractIdx}-${functionIdx}`}
                                contractName={contractName}
                                contractAddress={contractAddress}
                                contractAbi={[func]}
                                functionName={func.name}
                                functionInputs={func.inputs}
                                functionOutputs={func.outputs}
                                stateMutability={func.stateMutability}
                                gasLimit={gasLimit}
                                value={value}
                            />
                        )
                    ))}
                </Card.Body>
            </Accordion.Collapse>
        </Card>
    )
} 